import { BathProductPage, BathProductConfig } from "@/components/bath/BathProductPage";

const config: BathProductConfig = {
  slug: "vena-basin",
  category: "Counter Basin",
  productName: "VENA Counter Basin — Sculpted Solid Surface Washbasin",
  shortName: "VENA Basin",
  sku: "VENA-BASIN-560",
  schemaCategory: "Sinks > Counter Basins > Solid Surface",
  metaTitle: "VENA Counter Basin — Solid Surface Washbasin | Aureum VII",
  metaDescription:
    "VENA Counter Basin — sculpted solid surface washbasin for luxury bathrooms, hotels and branded residences. Seamless cast form, CE certified, MOQ-ready.",
  heroEyebrow: "Project Solutions · Counter Basin",
  heroHeadline: (
    <>
      Sculpted{" "}
      <span className="bg-gradient-to-r from-amber-300 via-amber-400 to-amber-200 bg-clip-text text-transparent">
        Solid Surface
      </span>{" "}
      Counter Basin
    </>
  ),
  heroIntro:
    "A sculpted countertop washbasin cast in a single seamless solid surface piece. VENA pairs an architectural exterior with a generous, ergonomic bowl — engineered for hotel suites, branded residences and signature powder rooms.",
  premiumSummary:
    "A counter-mounted solid surface washbasin with a sculpted exterior and seamless interior bowl. Hospitality-grade durability, designer-grade silhouette, and trade pricing built for project specification.",
  galleryImages: [
    {
      src: "/images/bath/vena-basin.jpg",
      alt: "VENA counter basin sculpted solid surface washbasin — hero shot",
      title: "VENA Basin — Hero",
      caption: "Hero · Sculpted counter basin",
      description: "Hero shot of the VENA counter basin in matte white solid surface, mounted on a stone vanity top.",
    },
    {
      src: "/images/bath/vena-basin-detail.jpg",
      alt: "VENA counter basin seamless interior bowl cast solid surface detail",
      title: "VENA Basin — Bowl Detail",
      caption: "Detail · Seamless bowl",
      description: "Macro detail of the VENA basin's seamless cast solid surface interior bowl and overflow.",
    },
    {
      src: "/images/bath/vena-basin-top.jpg",
      alt: "VENA counter basin top-down view sculpted oval form",
      title: "VENA Basin — Top View",
      caption: "View · Top-down",
      description: "Top-down view of the VENA basin showing the sculpted oval form and rim profile.",
    },
    {
      src: "/images/bath/vena-basin-suite.jpg",
      alt: "VENA counter basin installed in luxury hotel suite vanity",
      title: "VENA Basin — Suite Lifestyle",
      caption: "Lifestyle · Hotel vanity",
      description: "Lifestyle scene: VENA basin specified on a five-star hotel suite vanity with brushed brass tapware.",
    },
    {
      src: "/images/bath/vena-basin-residence.jpg",
      alt: "VENA counter basin in private residence powder room",
      title: "VENA Basin — Residence Lifestyle",
      caption: "Lifestyle · Private powder room",
      description: "Lifestyle scene: VENA basin in a private residence powder room with stone counter and walnut joinery.",
    },
  ],
  specs: [
    { label: "Dimensions", value: "560 × 380 × 130 mm (L × W × H)" },
    { label: "Material", value: "Cast Solid Surface (Stone Resin Composite)" },
    { label: "Finish", value: "Matte White (Gloss available on request)" },
    { label: "Installation", value: "Counter-mounted (above counter)" },
    { label: "Weight", value: "≈ 12 kg" },
    { label: "Drain", value: "1¼\" pop-up — Chrome / Brushed Gold / Matte Black" },
    { label: "Tap Hole", value: "Wall-mounted tap recommended (no deck hole)" },
    { label: "Certification", value: "CE Marked" },
    { label: "Warranty", value: "5 years structural · 2 years hardware" },
    { label: "MOQ (Container)", value: "Bulk pricing from 30+ units" },
  ],
  longDescription: [
    "VENA Counter Basin is a sculpted above-counter washbasin cast in a single seamless piece of solid surface stone-resin composite. The exterior reads as an architectural object; the interior is engineered as a generous, ergonomic bowl with concealed overflow.",
    "Non-porous, repairable in place, and warm to the touch, VENA outperforms ceramic on durability while delivering a sculptural silhouette that feels bespoke rather than catalogue.",
    "Specified by hotel groups, branded residences and high-end residential developers across Europe. Trade pricing, MOQ-ready supply, and OEM options available for project-scale orders.",
  ],
};

const VenaBasin = () => <BathProductPage config={config} />;
export default VenaBasin;
